import { IonCard, IonIcon } from '@ionic/react';
import { chevronForward, lockClosedOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { useRequiredDevicePaymentPlanInfo } from '../query/hasRequiredDevicePaymentPlan';
import styles from './RequiredPaymentBanner.module.css';

const RequiredPaymentBanner: React.FC = () => {
    const { t } = useTranslation('components');
    const history = useHistory();
    const { requiredDeviceIds, totalDeviceCount } = useRequiredDevicePaymentPlanInfo();

    if (requiredDeviceIds.length === 0) {
        return null;
    }

    const isSingleDevice = totalDeviceCount === 1;

    return (
        <IonCard
            button
            className={styles.card}
            onClick={() => history.push(isSingleDevice ? `/devices/${requiredDeviceIds[0]}` : '/devices')}
        >
            <div className={styles.content}>
                <div className={styles.iconChip}>
                    <IonIcon icon={lockClosedOutline} />
                </div>
                <div className={styles.message}>{t('required_payment_banner.unlock_message')}</div>
                <div className={styles.action}>
                    {t('required_payment_banner.action')}
                    <IonIcon icon={chevronForward} />
                </div>
            </div>
        </IonCard>
    );
};

export default RequiredPaymentBanner;
